export default "__VITE_ASSET__BMDuhIqA__"